import {api2Endpoint} from 'app/config/apiConfig'
import {useMutation} from 'react-query'
import toastr from 'toastr'
import {postData} from '../api/usePostData'
import {announceReturn, announceSend} from '../api/utils/announce'

interface Args {
  user_id: string
  subscription_id: string
  is_tenant_admin: boolean
  __via_delegation_id?: string
  invalidateKey?: string | Array<string>
}

export function useAddUserToSubscriptionV2(errMsg = 'Could not add user to subscription') {
  return useMutation(async (args: Args) => {
    try {
      const route = `std/subscription/${args.subscription_id}/users/${args.user_id}`
      announceSend('post', route, args.user_id)
      const json = args.__via_delegation_id
        ? {
            __is_tenant_admin: args.is_tenant_admin,
            __via_delegation_id: args.__via_delegation_id,
          }
        : {
            __is_tenant_admin: args.is_tenant_admin,
          }
      const retval = await postData<any>(api2Endpoint(route), json, 'post')
      announceReturn('post', route, args.user_id)
      return retval
    } catch (err) {
      toastr.error(errMsg)
    }
  })
}
